import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _cffe3db6 = () => interopDefault(import('~/pages/_.vue' /* webpackChunkName: "" */))
const _fe9de024 = () => interopDefault(import('../../../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _cffe3db6,
    name: "about"
  }, {
    path: "/careers",
    component: _cffe3db6,
    name: "careers"
  }, {
    path: "/contact",
    component: _cffe3db6,
    name: "contact"
  }, {
    path: "/copyright",
    component: _cffe3db6,
    name: "copyright"
  }, {
    path: "/from-divorce-to-financial-security-a-comprehensive-planning-journey",
    component: _cffe3db6,
    name: "from-divorce-to-financial-security-a-comprehensive-planning-journey"
  }, {
    path: "/how-an-executive-used-rsus-and-company-stock-planning-to-retire-5-years-early",
    component: _cffe3db6,
    name: "how-an-executive-used-rsus-and-company-stock-planning-to-retire-5-years-early"
  }, {
    path: "/level-up-your-money-game-3-2-1-insights-to-keep-you-sharp",
    component: _cffe3db6,
    name: "level-up-your-money-game-3-2-1-insights-to-keep-you-sharp"
  }, {
    path: "/meet-adam",
    component: _cffe3db6,
    name: "meet-adam"
  }, {
    path: "/meet-meredith",
    component: _cffe3db6,
    name: "meet-meredith"
  }, {
    path: "/meet-sandy",
    component: _cffe3db6,
    name: "meet-sandy"
  }, {
    path: "/services",
    component: _cffe3db6,
    name: "services"
  }, {
    path: "/the-legacy-builder-maximizing-business-value-for-a-strategic-exit",
    component: _cffe3db6,
    name: "the-legacy-builder-maximizing-business-value-for-a-strategic-exit"
  }, {
    path: "/resources/ebooksguides",
    component: _cffe3db6,
    name: "ebooksguides"
  }, {
    path: "/resources/faq",
    component: _cffe3db6,
    name: "faq"
  }, {
    path: "/resources/in-the-news",
    component: _cffe3db6,
    name: "in-the-news"
  }, {
    path: "/resources/speaking",
    component: _cffe3db6,
    name: "speaking"
  }, {
    path: "/resources/wealth-profiles",
    component: _cffe3db6,
    name: "wealth-profiles"
  }, {
    path: "/",
    component: _cffe3db6,
    name: "homepage"
  }, {
    path: "/*",
    component: _fe9de024,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
